import { createFileRoute } from '@tanstack/react-router';

/**
 * Tarefas do módulo Portfólio — filtra por vínculo de Investment (§7 do brief Portal Vega Bloco 1).
 * Componente vem de portfolio.tarefas.lazy.tsx (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/portfolio/tarefas')({});
